// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{padding-top:env(safe-area-inset-top);padding-bottom:env(safe-area-inset-bottom)}body img{max-width:100%;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
